import { lang } from '@umu/ukit-lang';
/*
 * @Author: zhaihaooran
 * @Date: 2021-07-03 15:49:59
 * @LastEditors: OBKoro1
 * @FilePath: /umu_mobile/src/businessCommon/components/@pageFooter/pageFooter.tsx
 */
/**
 * @description
 */

import React from 'react';
import { services, components } from 'common';
const { PreImg } = components;
const { getModuleData } = services;
import { $window } from '@umu/umu-dom';
import { getData } from '@umu/umu-util';
import umuWebview from '@umu/umu-webview';
import './pageFooter.scss';
import logo from './images/logo.png';
import { isFromCourseMiniApp } from '../../@utils/umuUtil';

export default function PageFooter() {
    const returnUrl = '?from_url=' + encodeURIComponent($window.location.href);
    const contextInfo = getModuleData('contextInfo');
    const isEnterprise = Number(getData(contextInfo, 'enterprise_info', 'enterprise_id')) > 0;
    if (isEnterprise || umuWebview.UA_INFO.isUMUWebview || isFromCourseMiniApp()) {
        return null;
    }
    return (
        <div className="common-page-footer">
            <div className="footer-wrap">
                <div className="support">
                    <a href={`/${returnUrl}`}>
                        <PreImg>
                            <img className="logo" src={logo} />
                        </PreImg>
                    </a>
                    <span>{lang('让每个人融入、分享、收获')}</span>
                </div>
                <div className="links">
                    <span>
                        <a href={`/${returnUrl}`}>{lang('了解UMU')}</a>
                        <em>|</em>
                        <a href={`/globaluser/registerpage${returnUrl}`}>{lang('注册UMU')}</a>
                        <em>|</em>
                        <a href="/feedback">{lang('反馈意见')}</a>
                    </span>
                </div>
                <p className="copyright">
                    {`Copyright © ${new Date().getFullYear()} UMU Co., Ltd. All Rights Reserved.`}
                </p>
            </div>
        </div>
    );
}
